import { MessengerInviteReasonVo } from "../../../vo/chat/invites/messenger-invite-reason-vo";
import { MessengerInviteVo } from "../../../vo/chat/invites/messenger-invite-vo";
var MessengerInviteVoConverter = /** @class */ (function () {
    function MessengerInviteVoConverter() {
    }
    MessengerInviteVoConverter.convertDtoToInviteVo = function (inviteResultDto, reason) {
        var inviteReasonVo = new MessengerInviteReasonVo();
        if (reason != null) {
            if (reason.hasAttribute("subject")) {
                inviteReasonVo.subject = reason.getAttribute("subject");
            }
            if (reason.hasAttribute("roomJid")) {
                inviteReasonVo.roomJid = reason.getAttribute("roomJid");
            }
            if (reason.hasAttribute("messageJid")) {
                inviteReasonVo.messageJid = reason.getAttribute("messageJid");
            }
            if (reason.hasAttribute("authorJid")) {
                inviteReasonVo.authorJid = reason.getAttribute("authorJid");
            }
            if (reason.hasAttribute("created")) {
                var dateValue = reason.getAttribute("created");
                inviteReasonVo.created = dateValue == null ? new Date() : new Date(+dateValue);
            }
            if (reason.hasAttribute("propertyName")) {
                inviteReasonVo.propertyName = reason.getAttribute("propertyName");
            }
            if (reason.hasAttribute("newValue")) {
                inviteReasonVo.newValue = reason.getAttribute("newValue");
            }
            if (reason.hasAttribute("oldValue")) {
                inviteReasonVo.oldValue = reason.getAttribute("oldValue");
            }
            if (reason.hasAttribute("lastMessageContent")) {
                inviteReasonVo.lastMessageContent = reason.getAttribute("lastMessageContent");
            }
            if (reason.hasAttribute("lastMessageTime")) {
                var dateValue = reason.getAttribute("lastMessageTime");
                inviteReasonVo.lastMessageTime = dateValue == null ? new Date() : new Date(+dateValue);
            }
            if (reason.hasAttribute("lastMessageAuthor")) {
                inviteReasonVo.lastMessageAuthor = reason.getAttribute("lastMessageAuthor");
            }
        }
        return new MessengerInviteVo(inviteResultDto.from.bare, inviteReasonVo, inviteResultDto.room.bare, inviteResultDto.type);
    };
    return MessengerInviteVoConverter;
}());
export { MessengerInviteVoConverter };
//# sourceMappingURL=messenger-invite-vo-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-vos-converters/jabber-vos-converters/messenger/messenger-invite-vo-converter.js
// module id = 537
// module chunks = 14